import { render } from "./payslip-request-model.vue?vue&type=template&id=93432236"
import script from "./payslip-request-model.vue?vue&type=script&lang=js"
export * from "./payslip-request-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__